import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";
import TextField from 'material-ui/TextField';

import cx from 'classnames';
import s from '../FormElement.css';

import portalTheme from "../../../themes/portalTheme";


const PortalTextField = ({
  className, description, disabled, errorText, id, fullWidth,
  label, multiLine, name, onChange, required, type, value, onBlur,
}) => {
  return (
    <div className={cx(s.component, className, {[`${s.disabled}`]: disabled})}>
      <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
        <TextField
          className={s.input}
          disabled={disabled}
          errorText={errorText}
          errorStyle={{color:'#B2120B'}}
          id={id}
          floatingLabelText={label}
          floatingLabelStyle={{color:'#222222'}}
          multiLine={multiLine}
          name={name}
          onChange={event => { if (onChange) onChange(event, event.target.value) }}
          onBlur={onBlur}
          type={type}
          value={value}
          fullWidth={fullWidth}
        />
      </MuiThemeProvider>
      {description && <div className={cx(s.description, {[`${s.moveDown}`]: errorText})}>{description}</div> }
    </div>
  );
};

PortalTextField.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  errorText: PropTypes.node,
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  multiLine: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.node,
  onBlur: PropTypes.func,
};

export default PortalTextField;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalTextField/PortalTextField.js